import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IRouterProps } from '@interfaces/App.interface';
import {
  generateGlobalColumns,
  generateBasicColumn,
  generateEntityColumn,
  IDataGridConfig,
  TInheritedProps,
} from '@ts/storybook';
import { IConfigComponent, CAddress, CAddressType } from '@ts/ui-models';

interface IAddressesTableProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
  addresses?: any[];
  title?: string;
  defaultCreationProperties?: any; //For new entity
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'addresses',
  aclId: 'taAddress',
  entity: 'address',
  fetchURL: '/api/addresses',
  crudURL: '/api/address',
  mainClass: CAddress,
};

const AddressesTable = (props: IAddressesTableProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: true },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      generateBasicColumn({ field: 'line1', headerName: 'Line 1' }, { field: 'line1' }),
      generateBasicColumn({ field: 'city' }, { field: 'city' }),
      generateBasicColumn({ field: 'zipCode', headerName: 'Zip code' }, { field: 'zipCode' }),
      generateBasicColumn({ field: 'state' }, { field: 'state' }),
      generateBasicColumn({ field: 'countryId', headerName: 'Country' }, { field: 'countryId' }),
      generateEntityColumn(
        { field: 'addressType', headerName: 'Address type' },
        { field: 'event', mainClass: CAddressType },
        { inheritedProps }
      ),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      title={props.title}
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      rows={{ count: props.addresses?.length ?? null, rows: props.addresses ?? [] }} //props.addresses}
      dataGridMode={props.addresses ? 'client' : 'server'}
      defaultCreationProperties={props.defaultCreationProperties}
      //Extra data
      inheritedProps={props.inheritedProps}
    />
  );
};

export default AddressesTable;
